import { render, staticRenderFns } from "./receiveTransferDetail.vue?vue&type=template&id=26aca8aa&"
import script from "./receiveTransferDetail.vue?vue&type=script&lang=js&"
export * from "./receiveTransferDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports